(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide-styles"] && !Shopify.designMode) return;
  try {
    if (!('commandForElement' in HTMLButtonElement.prototype)) {
    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('.size-guide__trigger[commandfor]');
      if (trigger) {
        event.preventDefault();
        const dialog = document.getElementById(trigger.getAttribute('commandfor'));
        if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
          dialog.showModal();
        }
        return;
      }

      const closer = event.target.closest('.size-guide__close[commandfor]');
      if (closer) {
        const dialog = document.getElementById(closer.getAttribute('commandfor'));
        if (dialog && dialog.open) dialog.close();
        return;
      }

      const openDialog = event.target.closest('dialog.size-guide__dialog');
      if (openDialog && event.target === openDialog) {
        openDialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
